module.exports = __webpack_public_path__ + "img/253.76d8bd05.jpg";